import Model, { attr } from '@ember-data/model';

export enum TaskEventName {
  created = 'task_created',
  updated = 'task_updated',
  transitioned = 'task_transitioned',
  assigned = 'task_assigned',
  unassigned = 'task_unassigned',
  accepted = 'task_accepted',
  declined = 'task_declined',
  attachmentAdded = 'task_attachment_added',
  attachmentReplaced = 'task_attachment_replaced',
  attachmentRemoved = 'task_attachment_removed',
  checklistItemAdded = 'checklist_item_added',
  checklistItemRemoved = 'checklist_item_removed',
  checklistItemCompleted = 'checklist_item_completed',
  checklistItemUncompleted = 'checklist_item_uncompleted',
  damageReported = 'task_damage_reported',
}

export type TaskEventPayload = Record<string, unknown>;

export default class TaskEventModel extends Model {
  @attr('string') eventName!: TaskEventName | string;
  @attr('object') before!: TaskEventPayload;
  @attr('object') after!: TaskEventPayload;
  @attr('date') createdAt!: Date;
  @attr('boolean') system!: boolean;
  @attr('string') actorName?: string | null;
  @attr('array') subjectNames!: string[];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'task-event': TaskEventModel;
  }
}
